import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';


const ParticipatingCollegesOld = () => {
  return (
    <section>

      <div className="about-mijsc-section w-full bg-cover h-fit pb-5">
        {/* SEO */}
        <Helmet>
          <title> Participating Colleges | LMP</title>
          <meta
            name="description"
            content="Contact Mizuho India Japan Study Centre (MIJSC), Indian Institute of Management Bangalore."
          />
        </Helmet>
        <BreadCrumbs />

        <h2 className='text-2xl mt-10  font-bold'>LMP Faculty Development Program - Batch 6, 2026-27</h2>
        <div className="my-5 md:my-5 space-y-2 text-left md:px-10 px-5 ">
          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              P. E. S. College of Engineering Chhatrapati Sambhajinagar - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Prashant Laxman Pandit</li>
                <li>Dr. Abhijit Sanjay Pande</li>
                <li>Mr. Abhijeet Arun Gaikawad</li>
                <li>Dr. Sahil Gopal Naghate</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Indian Institute of Technology Tirupati - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Ajay Kumar</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Srinivasa Institute of Technology and Management Studies, Chittoor - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Jyoshna C</li>
                <li>Dr. R. Priyadharsini</li>
                <li>Dr. K Yogaprasad</li>
                <li>Dr. S. Rajesh</li>
                <li>Dr. N. Venkatachalapathi</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              M. S. Ramaiah University of Applied Sciences, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Pramod A</li>
                <li>Mr. S Vijaya Kumar</li>
                <li>Mr. Sandeep N</li>
                <li>Dr. Aileen J</li>
                <li>Dr. Rahul M. Cadambi</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              SVKM NMIMS Global University, Dhule, Maharashtra - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Satish Ramesh Patil</li>
                <li>Dr. Hitesh Thakare</li>
                <li>Dr. Amol Chintaman Badgujar</li>
                <li>Mr. Karan Krishna Sharma</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Sri Venkateswara College of Engineering and Technology (Autonomous), Chittoor - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Jawahar S</li>
                <li>Mr. Sivalingam C</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Mohan Babu University, Tirupati - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Babu Devasenapati S</li>
                <li>Dr. Beyanagari Sudheer Reddy</li>
                <li>Mr. B. V. Sai Thrinath</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Jansons School of Business, Coimbatore - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Raghuram. P.</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Jansons Institute of Technology, Coimbatore - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Alexander F</li>
                <li>Dr. Raju M</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              RNS Institute of Technology, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. C. P. Lohith</li>
                <li>Mr. Vasanth Rao K. P</li>
                <li>Mr. Praveen G</li>
                <li>Mr. Mahadeva M</li>
                <li>Mr. Sachin R Kulkarni</li>
              </ul>
            </p>
          </details>
        </div>

        <h2 className='text-2xl mt-10  font-bold'>LMP Faculty Development Program - Batch 5, 2025-26</h2>
        <div className="my-5 md:my-5 space-y-2 text-left md:px-10 px-5 ">
          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              KPR Institute of Engineering and Technology, Coimbatore - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. N. Mathan Kumar</li>
                <li>Dr. Ravindran S</li>
                <li>Mr. Arunkumar N</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              BMS College of Engineering, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Kavitha Rani N</li>
                <li>Ms. Sumalatha</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Dayananda Sagar College of Engineering, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Rajesh S M</li>
                <li>Ms. Radha Halagani</li>
                <li>Dr. K. G. Hemalatha</li>
                <li>Dr. Haseebuddin M R</li>
                <li>Dr. Kali Charan Sabat</li>
                <li>Dr Ganesha K S</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              GD Goenka University, Gurugram - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Ashu</li>
                <li>Dr. Aakansha Singh</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              RNS Institute of Technology, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Dharmesh N</li>
                <li>Dr Abhijith C C</li>
                <li>Dr. Krishnan S</li>
                <li>Dr. Manjunath N</li>
                <li>Dr. Annapoorna K</li>
                <li>Dr. Bharath V</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              MS Ramaiah Institute of Technology, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Anand M Raikar</li>
                <li>Dr. Sagar J S</li>
                <li>Dr. Mohandas K N</li>
                <li>Mr. Niranjan G Hiremath</li>
                <li>Dr. Shobha R</li>
                <li>Dr. Samrat K</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Tatyasaheb Kore Institute of Engineering and Technology (TKIET), Warananagar - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Maheshkumar Vasantrao Jadhav</li>
                <li>Mr. Aviraj Parashuram Deshmukh</li>
                <li>Mr. Vaibhav Mohan Chougule</li>
                <li>Dr. Sharad Tukaram Jadhav</li>
                <li>Mr. Ravindranath Gorakhnath Kshirsagar</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Don Bosco Institute of Technology, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. R. Anguraja</li>
                <li>Dr. Meera Uday</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Walchand College of Engineering, Sangli - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Sagar U. Sapkal</li>
                <li>Dr. S. D. Ruikar</li>
                <li>Dr. Sharad Vasantrao Gaikwad</li>
                <li>Mr. Rahul Mohanrao Chanmanwar</li>
                <li>Dr. Jehier Abbas K Shaaikh</li>
                <li>Dr. Amar Shrikant Bhandare</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              RV College of Engineering, Bengaluru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Ekta Jain</li>
                <li>Dr Ramakrishna Hegde</li>
                <li>Dr. Girish Kumar R</li>
                <li>Mr. Pranesh Kumar S R</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Ashokrao Mane Group of Institutions, Kolhapur - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Sagar Shivaji Sutar</li>
                <li>Mr. Ganesh Dnyandev Lolage</li>
                <li>Dr. Sarvajeet Amarjeet Bhosale</li>
                <li>Mr. Amol A Patil</li>
                <li>Dr. Vinaya K Thombare (Chavan)</li>
                <li>Mr. Pravin Basaveshwar Ghewari</li>
                <li>Dr Jaydeep Mohanrao Shinde</li>
                <li>Mr. Rahul Anil Pasale</li>
              </ul>
            </p>
          </details>
        </div>


        <h2 className='text-2xl mt-10  font-bold'>LMP Faculty Development Program - Batch 4, 2025-26</h2>

        <div class="my-5 md:my-5 space-y-2 text-left md:px-10 px-5 ">
          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              K. J. Somaiya School of Engineering, Somaiya Vidyavihar University, Vidyavihar, Mumbai - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Vaibhav S. Narwane</li>
                <li>Dr. Ramesh Ramkisan Lekurwale</li>
                <li>Dr. Rajesh Pansare</li>
                <li>Dr. Manoj Anandrao Palsodkar</li>
                <li>Ms. Sheba Grace Varghese</li>
                <li>Dr. Manish Deo</li>
                <li>Mr. Abhijeet Uday Karmarkar</li>
                <li>Mr. Parag Sarode</li>
                <li>Ms. Shivangi Viral Thakker</li>
              </ul>
            </p>
          </details>


          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Fr. Conceicao Rodrigues College of Engineering, Bandra, Mumbai - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. VeerabhadraRao Miriyala</li>
                <li>Dr. Ketaki Narendra Joshi</li>
                <li>Dr. Vasim A. Shaikh</li>
                <li>Mr. Mayur Aggarwal</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Dwarkadas J Sanghvi College of Engineering, Mumbai - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Amit Chaudhari</li>
                <li>Mr. Dharam Vasant Ranka</li>
                <li>Ms. Trupti Markose</li>
                <li>Mr. Ramesh Ramling Rajguru</li>
                <li>Dr. Shashikant Auti</li>
                <li>Mr. Sanket Dattaram Parab</li>
                <li>Mr. Mehul Prajapati</li>
                <li>Mr. Dhaval Birajdar</li>
                <li>Dr. Sandip Hanumant Mane</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              J D College of Engineering and Management, Nagpur - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Ms. Yamini Piyush Dwivedi</li>
                <li>Ms. Niharika Singh</li>
                <li>Mr. Dhiraj A. Hande</li>
                <li>Mr. Prashant M Mahakalkar</li>
                <li>Mr. Rakesh Dilip Bandane</li>
                <li>Mr. Rajendra P. Dhandre</li>
                <li>Ms. Rasika R. Samrit</li>
                <li>Ms. Nikita Gajendra Tantarpale</li>
                <li>Mr. Chetan Premlal Padole</li>
                <li>Mr. Mohammad Hassan</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Sardar Patel College of Engineering, Mumbai - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Anupa Sabnis</li>
                <li>Dr. Santosh Bhagwat Rane</li>
                <li>Dr. Pravinchandra Gangadhar Gaikwad</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              KCG College of Technology, Chennai - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Dhamodaran K</li>
                <li>Mr. Manikandan S</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              GD Goenka University, Gurugram - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr Parul Sinha</li>
                <li>Dr. Ankita Singh</li>
                <li>Dr. Karina Bhatia Kakkar</li>
                <li>Dr. Nidhi Singh</li>
              </ul>
            </p>
          </details>







        </div>


        <h2 className='text-2xl mt-10  font-bold'>LMP Faculty Development Program - Batch 3, 2025-26</h2>
        <div class="my-5 md:my-5 space-y-2 text-left md:px-10 px-5 ">
          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              SNJB's Shri Hiralal Hastimal (Jain Brother's Jalgaon) Polytechnic, Chandwad, Nashik - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Sarode Kunal Vishwanath</li>
                <li>Mrs. Lajima Shubham Bairagi</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              SNJB's Late Sau. Kantabai Bhavarlalji Jain College of Engineering, Chandwad, Nashik - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Sancheti Santosh Dharamchand</li>
                <li>Mr. Pradyumna Mulchand Bora</li>
                <li>Mr. Harshal Suresh Deore</li>
                <li>Mr. Rajendra Shankarrao Chaudhari</li>
                <li>Mr. Kiran Balu Gore</li>
                <li>Mr. Manoj Ashok Mechkul</li>
                <li>Dr. Bhandari Rajiv Ramesh</li>
                <li>Dr. Amol Murgai</li>
                <li>Dr. Mahesh R. Sanghavi</li>
                <li>Mr. Praful Ananda Shinkar</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              MIT Academy of Engineering, Alandi, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Amol Madhukar Kolhe</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Sree Chitra Thirunal College of Engineering, Thiruvananthapuram - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Kavilal E G</li>
                <li>Dr. Sreejith B J</li>
                <li>Dr. Rinu Sathyan</li>
                <li>Dr. Anoop M. S.</li>
                <li>Ms. Ameena A</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              K. K. Wagh Institute of Engineering Education and Research, Nashik - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Rohit Vasantrao Bhaskar</li>
                <li>Mr. Rahul Damodhar Rakhade</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Vishwakarma Institute of Technology, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Gajanan Mahadeo Gambhire</li>
                <li>Dr. Vijaykumar Bhanuse</li>
                <li>Dr. Deepali Jayant Joshi</li>
                <li>Dr. Radhika Vikas Kulkarni</li>
                <li>Dr. Satchidanand Satpute</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Gokhale Education Society's R.H. Sapat College of Engineering, Management Studies and Research, Nashik - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Raju Sidhu Pawar</li>
                <li>Mr. Ravindra Ashok Tarle</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Jaihind College of Engineering, Kuran - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Mr. Paresh Sudam Pawar</li>
                <li>Mr. Ramdas Anantrao Gadekar</li>
                <li>Mr. Arvind Laxman Dhobale</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Tatyasaheb Kore Institute of Engineering and Technology, Warananagar, Kolhapur - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Mahesh Rama Jadhav</li>
                <li>Mr. Sachinkumar Shashikant Mahadik</li>
                <li>Mr. Vivek Vijayrao Patil</li>
                <li>Mr. Vishwajit Vishwas Patil</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              JSPM’s Jayawantrao Sawant College of Engineering, Hadapsar, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Ms. Neeta S. Pingle</li>
                <li>Ms. Shubhangi Parmeshwar Arbale</li>
                <li>Mr. Prakash Tukaram Patil</li>
                <li>Dr. Shailesh M Hambarde</li>
                <li>Dr. Priya Nitin Gokhale</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Nutan Maharashtra Institute of Engineering & Technology, Talegaon, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Sapali Shivalingappa Nagappa</li>
                <li>Mr. Aniruddh Chandrakant Dubal</li>
                <li>Ms. Uttara Varade</li>
                <li>Mr. Rahul Arun Patil</li>
                <li>Ms. Uma Patil</li>
                <li>Dr. Ashwini Shinde</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              JSS Science and Technology University, SJCE, Mysuru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Neetha K</li>
                <li>Ms. Sowmya C</li>
                <li>Dr. Rakesh D</li>
                <li>Dr. Sridevi Kulenur</li>
                <li>Dr. Savitha U. Ulavi</li>
                <li>Dr. Rekha M N</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Siddaganga Institute of Technology, Tumakuru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. G V Prabhushankar</li>
                <li>Dr. B. Latha Shankar</li>
                <li>Dr. T R Veena</li>
                <li>Dr. C. Poornima</li>
                <li>Dr. Vineeth Kumar T V</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Vidyavardhaka College of Engineering, Mysuru - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. P.S.V Balaji Rao</li>
                <li>Dr. Shilpa B S</li>
                <li>Dr. Raghu N</li>
                <li>Dr. Somashekhar I C</li>
                <li>Dr. Nithyananda B S</li>
                <li>Dr. Lakshmi P</li>
                <li>Mr. Manoj P</li>
                <li>Mr. Goutham B</li>
              </ul>
            </p>
          </details>

        </div>


        <h2 className='text-2xl mt-10  font-bold'> LMP Faculty Development Program - Batch 2, 2024-25 </h2>
        <div class="my-5 md:my-5 space-y-2 text-left md:px-10 px-5 ">
          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              National Institute of Technology Warangal - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Krishnanand Lanka</li>
                <li>Dr. P. R. C. Gopal</li>
                <li>Prof. Velagapudi Vasu</li>
                <li>Dr. Vijay Choyal</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Dr. D. Y. Patil Institute of Technology, Pimpri Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Jitendra Sharad Narkhede</li>
                <li>Prof. Gorakh Popatrao Bhagat</li>
                <li>Dr. Amit S. Chaudhary</li>
                <li>Prof. Armaan Suhel Shaikh</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              JSPM's Jayawantrao Sawant College of Engineering - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Siddhesh Chandrakant Bandekar</li>
                <li>Prof. Shivanand Talwar</li>
                <li>Dr. Prakash Kadam</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Marathwada Mitra Mandal's Institute of Technology, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Sudhir Sarjerao More</li>
                <li>Prof. Nilesh Dhobale</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Amrutvahini College of Engineering, Sangamner - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Raktate Omesh Uttamrao</li>
                <li>Prof. Eknath Tryambakrao Bayas</li>
                <li>Prof. Gite Ravindra Eknath</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              MIT College of Engineering, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Surendra Barewar</li>
                <li>Prof. Mamta D Sardare</li>
                <li>Prof. Ashwin S. Chandore</li>
                <li>Prof. Venugopal Kulkarni</li>
                <li>Prof. Vivek N Deshmukh</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Nutan College of Engineering and Research, Talegaon Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Aparna Pande</li>
                <li>Dr. Sagar Bhilaji Shinde</li>
                <li>Dr. Sanjeevkumar Angadi</li>
                <li>Dr. Mukund Ramdas Kharde</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Malnad College of Engineering - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Sharath H K</li>
                <li>Dr. Raghavendra Rao R</li>
                <li>Dr. Yashas Gowda T G</li>
                <li>Dr. Jeevan T.P.</li>
                <li>Dr. Divya H. V</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Marathwada Mitra Mandal's Polytechnic, Thergaon, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Ganesh Shankarrao Mhalankar</li>
                <li>Prof. Shrinivas Kulkarni</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Marathwada Mitra Mandal's College of Pharmacy - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Babita A. Agarwal</li>
                <li>Prof. Sharvari Sudhakar Bhore</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              TKM College of Engineering - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Anu V. Thomas</li>
                <li>Prof. Hazeena R</li>
                <li>Dr. Mubarak Ali M</li>
                <li>Dr. Femina A</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Dr. Vishwanath Karad MIT World Peace University, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Niranjan Dhanraj Khaire</li>
                <li>Dr. Shivprakash Bhagwatrao Barve</li>
                <li>Prof. Vaibhav Vijay Kulkarni</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Marathwada Mitra Mandal's College of Engineering, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Martand Pandagale</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Amity University Haryana - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Lucky Krishnia</li>
                <li>Dr. Monica Arora</li>
                <li>Dr. Ajay Kumar Pandey</li>
                <li>Dr. Leena Bhardwaj</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              JSPM’s Rajarshi Shahu College of Engineering, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Mangesh Ambadas Ahire</li>
                <li>Dr. Yashwant Umrao Chapke</li>
                <li>Dr. Ashish Kumar</li>
              </ul>
            </p>
          </details>

        </div>

        <h2 className='text-2xl mt-10  font-bold'>LMP Faculty Development Program - Batch 1, 2023-24 </h2>
        <div class="my-5 md:my-5 space-y-2 text-left md:px-10 px-5 ">

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              KLS Gogte Institute of Technology, Belgaum - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Harshit B. Kulkarni</li>
                <li>Dr. Ganesh R. Chate</li>
                <li>Dr. Rudresh B Magadum</li>
                <li>Prof. Anand A Kulkarni</li>
                <li>Prof. IshwaraGowda V Patil</li>
                <li>Prof. Santhosh S Kulkarni</li>
                <li>Prof. Purushotham P Katti</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Bhartesh Education Trust's Motichand Lengade Bhartesh Polytechnic - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Sangam Patil</li>
                <li>Prof. Mayur Kerimath</li>
                <li>Prof. Aishwarya A Patil</li>
                <li>Prof. Dhiraj Hirachand Jakkannavar</li>
                <li>Prof. Shrenik Suresh Patil</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Nutan College of Engineering & Research (NCER) - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Mujahid K. Shaikh</li>
                <li>Prof. Hanmant Sambhaji Gore</li>
                <li>Prof. Bhushan Shankarrao Pawar</li>
                <li>Prof. Deepak R. Naik</li>
                <li>Dr. Prasannata Dhanaji Ramtirthe</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Nutan Maharashtra Institute of Engineering & Technology, Pune - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Dr. Anuj Khond</li>
                <li>Prof. Mahesh Chinchole</li>
                <li>Prof. Vivek Nagargoje</li>
                <li>Prof. Ashish Patel</li>
              </ul>
            </p>
          </details>

          <details className="shadow rounded cursor-pointer">
            <summary className="font-semibold text-sm md:text-lg rounded-sm bg-green-600 text-white p-3">
              Marathwada Mitra Mandal's Polytechnic - Faculty Details
            </summary>
            <p className="mt-2 p-3 text-sm md:text-base">
              <ul className="list-decimal list-inside space-y-1">
                <li>Prof. Ashish G Dandge</li>
                <li>Prof. Prabhakar S Sakhare</li>
              </ul>
            </p>
          </details>

        </div>

      </div>
    </section>
  )
}

export default ParticipatingCollegesOld
